module.exports = __webpack_public_path__ + "static/media/static-vcr.1355bf00.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-vcr.gif
// module id = 374
// module chunks = 0